import axios from 'axios';

const TOKEN_KEY = 'yishu_huisuan_token';

const api = axios.create({
  baseURL: '/api',
  timeout: 60000
});

api.interceptors.request.use((config) => {
  const token = getStoredToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function getStoredToken() {
  return localStorage.getItem(TOKEN_KEY) || '';
}

export function setStoredToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

export async function register(payload) {
  const { data } = await api.post('/auth/register', payload);
  setStoredToken(data.token);
  return data;
}

export async function login(payload) {
  const { data } = await api.post('/auth/login', payload);
  setStoredToken(data.token);
  return data;
}

export async function fetchMe() {
  const { data } = await api.get('/auth/me');
  return data.user;
}

export async function updateProfile(payload) {
  const { data } = await api.put('/auth/profile', payload);
  return data.user;
}

export async function logout() {
  try {
    await api.post('/auth/logout');
  } finally {
    setStoredToken('');
  }
}

export async function fetchPlans() {
  const { data } = await api.get('/orders/plans');
  return data.plans;
}

export async function fetchSubscription(deviceId) {
  const { data } = await api.get('/orders/subscription/status', { params: { deviceId } });
  return data;
}

export async function createOrder(deviceId, plan) {
  const { data } = await api.post('/orders', { deviceId, plan });
  return data.order;
}

export async function mockPay(orderId) {
  const { data } = await api.post(`/orders/${orderId}/mock-pay`);
  return data.order;
}

export async function createDivination(payload) {
  const { data } = await api.post('/divinations', payload);
  return data;
}

export async function fetchHistory(deviceId) {
  const { data } = await api.get('/divinations/history', { params: { deviceId } });
  return data.records;
}
